<template>
	<BaseButton
		class="button"
		:classes="buttonClasses"
		:is-working="isWorking"
		:mixpanel-custom-properties="mixpanelCustomProperties"
		:mixpanel-target="clickText"
		:aria-disabled="v$.$invalid"
		type="submit"
		@click="onClick()"
	>
		<slot> Submit </slot>
	</BaseButton>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { MixpanelContext } from 'types/analytics';
import { useAnalyticsProperties } from '@utils/composables/use-analytics-properties';

interface Props {
	classes?: string;
	isWorking?: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	v$?: any;
	clickText?: string;
	mixpanelCustomProperties?: MixpanelContext;
}
const props = withDefaults(defineProps<Props>(), {
	classes: 'button-primary',
	isWorking: undefined,
	v$: undefined,
	clickText: undefined,
	mixpanelCustomProperties: undefined
});

interface Emits {
	(e: 'sb-click'): void;
}
const emit = defineEmits<Emits>();

const buttonClasses = computed((): string => {
	if (props.v$.$invalid) {
		return `${props.classes} disabled`;
	}

	return `${props.classes}`;
});

const validationErrors = ref<MixpanelContext>({ validationErrors: undefined });
const { setCustomProperties } = useAnalyticsProperties();
setCustomProperties(validationErrors);

function onClick(): void {
	if (!props.isWorking) {
		if (!props.v$.$invalid) {
			validationErrors.value.validationErrors = undefined;
			emit('sb-click');
		} else {
			validationErrors.value.validationErrors = props.v$.$errors;
			props.v$.$touch();
		}
	}
}
</script>
